export enum MainDtmfKey {
  OpeningTime = 'openingTime',
  OrderProduct = 'orderProduct',
  CreateTicket = 'createTicket',
  RedirectToPharmacy = 'redirectToPharmacy',
}
